import React from 'react';
import { Link } from 'react-router-dom';
import { FolderOpenIcon, LineChartIcon, TableIcon } from 'lucide-react';
import { useAssessment } from '../contexts/AssessmentContext';
import { LedgerTable } from '../components/workspace/LedgerTable';
import { BudgetTable } from '../components/workspace/BudgetTable';
import { DocumentViewer } from '../components/workspace/DocumentViewer';
import { AIChat } from '../components/workspace/AIChat';
import { ReflectionPanel } from '../components/workspace/ReflectionPanel';
import { TabId } from '../types/assessment';
const TABS: {
  id: TabId;
  label: string;
  icon: typeof TableIcon;
}[] = [{
  id: 'reconciliation',
  label: 'Reconciliation',
  icon: TableIcon
}, {
  id: 'budget',
  label: 'P&L vs Budget',
  icon: LineChartIcon
}, {
  id: 'documents',
  label: 'Source documents',
  icon: FolderOpenIcon
}];
export function Workspace() {
  const {
    startedAt,
    activeTab,
    setActiveTab,
    timeUp,
    submitted
  } = useAssessment();
  if (!startedAt) {
    return <main className="flex w-full flex-1 items-center justify-center bg-slate-100 p-6" data-id="element-777" data-mp="2i5qgrk76x7xq">
        <div className="max-w-md rounded-xl border border-slate-200 bg-white p-8 text-center" data-id="element-778" data-mp="2d6x57xbgrr07">
          <h1 className="text-lg font-semibold text-slate-900" data-id="element-779" data-mp="2rvt7teur4btf">The assessment hasn&apos;t started</h1>
          <p className="mt-2 text-sm text-slate-600" data-id="element-780" data-mp="2n535ybljar3h">
            Read the briefing and start the clock before entering the workspace.
          </p>
          <Link to="/briefing" className="mt-5 inline-block rounded-md bg-slate-900 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-slate-700" data-id="element-781" data-mp="30v6iubyix8g9">
            Go to briefing
          </Link>
        </div>
      </main>;
  }
  return <main className="w-full flex-1 bg-slate-100" data-id="element-782" data-mp="35wm2q0oyt8x2">
      {(timeUp || submitted) && <div className="border-b border-slate-800 bg-slate-900 px-6 py-2.5 text-center text-sm text-slate-200" data-id="element-783" data-mp="1gfuw1386vboi">
          {submitted ? 'Submitted — this workspace is now read-only.' : 'Time is up. The ledger is read-only; complete your reflection below and submit.'}
        </div>}

      <div className="mx-auto max-w-[1600px] px-6 py-6" data-id="element-784" data-mp="3gjozed5pcr3q">
        <div className="grid min-h-0 gap-5 lg:grid-cols-[minmax(0,1fr)_400px]" data-id="element-785" data-mp="3kkhcxillxi5t">
          <div className="flex h-[72vh] min-h-[560px] flex-col overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm" data-id="element-786" data-mp="3kmu0qce1qmqs">
            <div className="flex items-center gap-1 border-b border-slate-200 bg-slate-50 px-3 pt-2.5" data-id="element-787" data-mp="3uj6q4y2k6efq">
              {TABS.map(tab => {
              const active = tab.id === activeTab;
              return <button key={tab.id} type="button" onClick={() => setActiveTab(tab.id)} aria-current={active ? 'page' : undefined} className={`flex items-center gap-2 rounded-t-md border border-b-0 px-4 py-2 text-[13px] font-medium transition-colors ${active ? 'border-slate-200 bg-white text-slate-900' : 'border-transparent text-slate-500 hover:text-slate-800'}`} data-id="element-788" data-mp="84dnpjc3n267">
                    <tab.icon className="h-3.5 w-3.5" data-id="element-789" data-mp="m7uihk4xr1rq" />
                    {tab.label}
                  </button>;
            })}
            </div>

            <div className="min-h-0 flex-1 overflow-hidden" data-id="element-790" data-mp="i9dlvuj559ok">
              {activeTab === 'reconciliation' && <LedgerTable data-id="element-791" data-mp="1ez4e1n3ymkr7" />}
              {activeTab === 'budget' && <BudgetTable data-id="element-792" data-mp="19zi2di3s5cki" />}
              {activeTab === 'documents' && <DocumentViewer data-id="element-793" data-mp="1578hwhlfp4pm" />}
            </div>
          </div>

          <div className="h-[72vh] min-h-[560px] overflow-hidden rounded-xl border border-slate-200 shadow-sm" data-id="element-794" data-mp="155dtgtayeugs">
            <AIChat data-id="element-795" data-mp="1142b98uetbim" />
          </div>
        </div>
      </div>

      <ReflectionPanel data-id="element-796" data-mp="1xokq97p0c1ng" />
    </main>;
}